import { Components, Theme } from '@mui/material'
import PaletteTheme from '../palette'

const button: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: ({ ownerState }) => ({
      textTransform: 'none',
      ...(ownerState.variant === 'text' && {
        color: ownerState.color ?? PaletteTheme.grey?.[500],
        fontSize: '14px',
        fontWeight: 700
      }),
      ...(['contained', 'outlined'].indexOf(ownerState.variant as string) > -1 && {
        fontSize: '15px',
        fontWeight: 700,
        borderRadius: '8px'
      })
    })
  },
  defaultProps: {
    disableElevation: true
  }
}

export default button
